


// import {
//   FETCH_DASHBOARD_STATS_REQUEST,
//   FETCH_DASHBOARD_STATS_SUCCESS,
//   FETCH_DASHBOARD_STATS_FAILURE,
//   FETCH_DISTRICT_USERS_REQUEST,
//   FETCH_DISTRICT_USERS_SUCCESS,
//   FETCH_DISTRICT_USERS_FAILURE,
//   FETCH_DISTRICT_TASK_SUBMIT_REQUEST,
//   FETCH_DISTRICT_TASK_SUBMIT_SUCCESS,
//   FETCH_DISTRICT_TASK_SUBMIT_FAILURE,
//   FETCH_MUNICIPALITY_ATTENDANCE_REQUEST,
//   FETCH_MUNICIPALITY_ATTENDANCE_SUCCESS,
//   FETCH_MUNICIPALITY_ATTENDANCE_FAILURE,
// } from "../actions/dashboardActions";

// const initialState = {
//   stats: {},
//   districtUsers: [],
//   districtTaskSubmit: [],
//   municipalityAttendanceToday: [],
//   loading: false,
//   error: null,
// };

// const dashboardReducer = (state = initialState, action) => {
//   switch (action.type) {
//     case FETCH_DASHBOARD_STATS_REQUEST:
//     case FETCH_DISTRICT_USERS_REQUEST:
//     case FETCH_DISTRICT_TASK_SUBMIT_REQUEST:
//     case FETCH_MUNICIPALITY_ATTENDANCE_REQUEST:
//       return { ...state, loading: true, error: null };

//     case FETCH_DASHBOARD_STATS_SUCCESS:
//       return { ...state, loading: false, stats: action.payload };

//     case FETCH_DISTRICT_USERS_SUCCESS:
//       return { ...state, loading: false, districtUsers: action.payload };

//     case FETCH_DISTRICT_TASK_SUBMIT_SUCCESS:
//       return { ...state, loading: false, districtTaskSubmit: action.payload };

//     case FETCH_MUNICIPALITY_ATTENDANCE_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         municipalityAttendanceToday: action.payload,
//       };

//     case FETCH_DASHBOARD_STATS_FAILURE:
//     case FETCH_DISTRICT_USERS_FAILURE:
//     case FETCH_DISTRICT_TASK_SUBMIT_FAILURE:
//     case FETCH_MUNICIPALITY_ATTENDANCE_FAILURE:
//       return { ...state, loading: false, error: action.payload };

//     default:
//       return state;
//   }
// };

// export default dashboardReducer;


import {
  FETCH_DASHBOARD_STATS_REQUEST,
  FETCH_DASHBOARD_STATS_SUCCESS,
  FETCH_DASHBOARD_STATS_FAILURE,
  FETCH_DISTRICT_USERS_REQUEST,
  FETCH_DISTRICT_USERS_SUCCESS,
  FETCH_DISTRICT_USERS_FAILURE,
  FETCH_DISTRICT_TASK_SUBMIT_REQUEST,
  FETCH_DISTRICT_TASK_SUBMIT_SUCCESS,
  FETCH_DISTRICT_TASK_SUBMIT_FAILURE,
  FETCH_MUNICIPALITY_ATTENDANCE_REQUEST,
  FETCH_MUNICIPALITY_ATTENDANCE_SUCCESS,
  FETCH_MUNICIPALITY_ATTENDANCE_FAILURE,
  FETCH_MUNICIPALITY_ATTENDANCE_DEFAULTERS_REQUEST,
  FETCH_MUNICIPALITY_ATTENDANCE_DEFAULTERS_SUCCESS,
  FETCH_MUNICIPALITY_ATTENDANCE_DEFAULTERS_FAILURE
} from "../actions/dashboardActions";

const initialState = {
  stats: {},
  districtUsers: [],
  districtTaskSubmit: [],
  municipalityAttendanceToday: [],
  municipalityAttendanceDefaultersToday: [],
  loading: false,
  error: null,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_STATS_REQUEST:
    case FETCH_DISTRICT_USERS_REQUEST:
    case FETCH_DISTRICT_TASK_SUBMIT_REQUEST:
    case FETCH_MUNICIPALITY_ATTENDANCE_REQUEST:
    case FETCH_MUNICIPALITY_ATTENDANCE_DEFAULTERS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_DASHBOARD_STATS_SUCCESS:
      return { ...state, loading: false, stats: action.payload };

    case FETCH_DISTRICT_USERS_SUCCESS:
      return { ...state, loading: false, districtUsers: action.payload };

    case FETCH_DISTRICT_TASK_SUBMIT_SUCCESS:
      return { ...state, loading: false, districtTaskSubmit: action.payload };

    case FETCH_MUNICIPALITY_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        municipalityAttendanceToday: action.payload,
      };

    case FETCH_MUNICIPALITY_ATTENDANCE_DEFAULTERS_SUCCESS:
      return {
        ...state,
        loading: false,
        municipalityAttendanceDefaultersToday: action.payload,
      };

    case FETCH_DASHBOARD_STATS_FAILURE:
    case FETCH_DISTRICT_USERS_FAILURE:
    case FETCH_DISTRICT_TASK_SUBMIT_FAILURE:
    case FETCH_MUNICIPALITY_ATTENDANCE_FAILURE:
    case FETCH_MUNICIPALITY_ATTENDANCE_DEFAULTERS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default dashboardReducer;
